<div class="arvore">
  <div *ngIf="isLoading" style="min-height: 420px" class="d-flex flex-column justify-content-center align-items-center">
    <mat-spinner color="primary" mode="indeterminate"></mat-spinner>
    <span class="mt-3" style="font-size: 14px;">Carregando módulos. Aguarde...</span>
  </div>
  <mat-tree #tree [hidden]="isLoading" [dataSource]="dataSource" [treeControl]="treeControl" class="example-tree">
    <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
      <li class="mat-tree-node" [ngClass]="hasCheckbox ? 'align' : ''">
        <button mat-icon-button disabled></button>
        <mat-checkbox *ngIf="hasCheckbox" class="checklist-leaf-node" color="primary"
          (change)="checkItem($event.checked, node)" [checked]="node.selected">
          {{ node.nome }}
          <small class="base-padrao" *ngIf="node.permiteAlterarBaseOrigem && node.moduloBaseOrigemId == 1"><i
              class="fas fa-database"></i> padrão</small>
          <small class="base-relatorios" *ngIf="node.permiteAlterarBaseOrigem && node.moduloBaseOrigemId == 2"><i
              class="fas fa-database" aria-hidden="true"></i> relatórios</small>
          <small class="base-historico" *ngIf="node.permiteAlterarBaseOrigem && node.moduloBaseOrigemId == 3"><i
              class="fas fa-database"></i> histórico</small>

        </mat-checkbox>
        <span *ngIf="!hasCheckbox">
          {{ node.nome }}
          <small class="base-padrao" *ngIf="node.permiteAlterarBaseOrigem && node.moduloBaseOrigemId == 1"
            matTooltip="Permite alteração da base de dados"><i class="fas fa-database"></i> padrão</small>
          <small class="base-relatorios" *ngIf="node.permiteAlterarBaseOrigem && node.moduloBaseOrigemId == 2"
            matTooltip="Permite alteração da base de dados"><i class="fas fa-database" aria-hidden="true"></i>
            relatórios</small>
          <small class="base-historico" *ngIf="node.permiteAlterarBaseOrigem && node.moduloBaseOrigemId == 3"
            matTooltip="Permite alteração da base de dados"><i class="fas fa-database"></i> histórico</small>
        </span>
      </li>
    </mat-tree-node>
    <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
      <li>
        <div class="mat-tree-node" [ngClass]="hasCheckbox ? 'align' : ''">
          <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'toggle ' + node.nome">
            <mat-icon class="mat-icon-rtl-mirror">
              {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
            </mat-icon>
          </button>
          <mat-checkbox *ngIf="hasCheckbox" [checked]="node.selected" color="primary"
            [indeterminate]="node.indeterminate && !node.selected" (change)="checkItem($event.checked, node)">
            {{ node.nome }}
            <small class="base-padrao" *ngIf="node.permiteAlterarBaseOrigem && node.moduloBaseOrigemId == 1"><i
                class="fas fa-database"></i> padrão</small>
            <small class="base-relatorios" *ngIf="node.permiteAlterarBaseOrigem && node.moduloBaseOrigemId == 2"><i
                class="fas fa-database" aria-hidden="true"></i> relatórios</small>
            <small class="base-historico" *ngIf="node.permiteAlterarBaseOrigem && node.moduloBaseOrigemId == 3"><i
                class="fas fa-database"></i> histórico</small>
          </mat-checkbox>
          <span *ngIf="!hasCheckbox">
            {{ node.nome }}
            <small class="base-padrao" *ngIf="node.permiteAlterarBaseOrigem && node.moduloBaseOrigemId == 1"
              matTooltip="Permite alteração da base de dados"><i class="fas fa-database"></i> padrão</small>
            <small class="base-relatorios" *ngIf="node.permiteAlterarBaseOrigem && node.moduloBaseOrigemId == 2"
              matTooltip="Permite alteração da base de dados"><i class="fas fa-database" aria-hidden="true"></i>
              relatórios</small>
            <small class="base-historico" *ngIf="node.permiteAlterarBaseOrigem && node.moduloBaseOrigemId == 3"
              matTooltip="Permite alteração da base de dados"><i class="fas fa-database"></i> histórico</small>
          </span>
        </div>
        <ul [class.start-collapsed]="!treeControl.isExpanded(node)">
          <ng-container matTreeNodeOutlet></ng-container>
        </ul>
      </li>
    </mat-nested-tree-node>
  </mat-tree>
</div>